import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { showSaveUserGroupDialog } from '../actions/usergroups/create';
import { updateUserGroupProperties, updateUserGroup } from '../actions/usergroups/update';
import { validateUserGroupDescription, validateUserGroupName } from '../helper';

const SaveUserGroupAction = ({
  category,
  code,
  isDirty,
  isEditing,
  saveStatus,
  showSave,
  update,
  updateProperties,
  userGroup,
}) => {
  const intl = useIntl();
  const isSaving = (saveStatus === states.PENDING);

  const validateForm = () => [
    validateUserGroupName(userGroup, intl),
    validateUserGroupDescription(userGroup, intl),
  ].filter((truthy) => !!truthy);

  const checkForErrors = () => {
    const validationErrors = validateForm();
    updateProperties(category, code, { saveErrors: validationErrors });

    return validationErrors;
  };

  const onSaveClick = () => {
    const validationErrors = checkForErrors();

    if (validationErrors.length > 0) {
      return;
    }

    if (!userGroup.isNew) {
      update(category, code);
      return;
    }

    showSave(category, code);
  };

  return (
    <RibbonMenu
      name="save"
      icon="save"
      disabled={!isEditing || !isDirty || isSaving}
      message="actions.save"
      onClick={onSaveClick}
      className="aridhia-save-usergroup-action"
      loading={isSaving}
    />
  );
};

const mapStateToProps = ({
  userGroups: { userGroups },
}, { category, code }) => {
  const userGroup = findResult(userGroups, category, code);

  if (userGroup) {
    return {
      userGroup,
      isEditing: userGroup.isEditing,
      isDirty: userGroup.isDirty,
      saveStatus: userGroup.saveStatus,
    };
  }

  return {
    userGroup: null,
    isEditing: false,
    isDirty: false,
    saveStatus: states.NONE,
  };
};

const mapDispatchToProps = {
  update: updateUserGroup,
  showSave: showSaveUserGroupDialog,
  updateProperties: updateUserGroupProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveUserGroupAction);
